import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import dateFormat from "dateformat";
const SingleItem = ({ data, index }) => {

    const userData = data?.user_id;
    const network = data?.network_id;

    return (
        <>
            <tr>
                <td data-label="Gateway | Transaction">
                    <span className="fw-bold"> {network?.network}</span>
                    <br />
                    <small> {data?.transaction} </small>
                </td>

                <td data-label="Initiated">
                    {dateFormat(data?.createdAt, "d-m-yyyy h:MM:ss TT")}<br />
                </td>
                <td data-label="User">
                    <Link to={`/agent/user/details/${userData?._id}`}>
                        <span className="fw-bold">{userData?.username} </span>
                    </Link>

                </td>

                <td data-label="Amount">
                    ${data?.amount}
                </td>

                <td data-label="Status">
                    {data.status === 0 ?
                        <span className="badge badge--warning text-warning">Pending</span>
                        : ''}
                    {data.status === 1 ?
                        <span className="badge badge--success text-success">Approved</span>
                        : ''}
                    {data.status === 2 ?
                        <span className="badge badge--danger text-danger">Rejected</span>
                        : ''}
                </td>
                <td data-label="Action">
                    <Link to={`/agent/deposit/detail/${data?._id}`} className="btn btn-sm btn-outline-primary ms-1">
                        <i className="la la-desktop"></i> Details                                    </Link>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;